import Vue from 'vue'
import VueRouter from 'vue-router'
import routerInstance from './instance'
import routerAdmin from './admin'
import routerGroup from './group'

import axios from 'axios'
import store from '@/store/index'
import VueCookies from 'vue-cookies'
Vue.use(VueCookies);

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/instance/login'
  },
  /* -------------------------------- AUTH INSTANCE ------------------------------- */
  {
      path: '/instance/login',
      name: 'instanceLogin',
      component: () => import('../views/instance/auth/login.vue')
  },
  /* -------------------------------- INSTANCE PAGE ------------------------------- */
  {
    path: '/instance',
    component: () => import('../views/main'),
    meta: { authInstance: true },
    children: [
      ...routerInstance
    ]
  },
  /* -------------------------------- AUTH GROUP ------------------------------- */
  {
      path: '/group/login',
      name: 'groupLogin',
      component: () => import('../views/group/auth/login.vue')
  },
  /* -------------------------------- GROUP PAGE ------------------------------- */
  {
    path: '/group',
    component: () => import('../views/main'),
    meta: { authGroup: true },
    children: [
      ...routerGroup
    ]
  },
  /* -------------------------------- AUTH ADMIN ------------------------------- */
  {
      path: '/admin/login',
      name: 'adminLogin',
      component: () => import('../views/admin/auth/login.vue')
  },
  /* -------------------------------- ADMIN PAGE ------------------------------- */
  {
    path: '/admin',
    component: () => import('../views/main'),
    meta: { authAdmin: true },
    children: [
      ...routerAdmin
    ]
  },

  /* -------------------------------- ERROR PAGE ------------------------------- */
  {
    path: '/404',
    component: () => import('../views/error/404')
  },
  {
    path: '/403',
    component: () => import('../views/error/403')
  },
  {
    path: '/500',
    component: () => import('../views/error/500')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


router.beforeEach(async (to, from, next) => {
  // IF GUARDED WITH INSTANCE
  if (to.matched.some(record => record.meta.authInstance)) {
    // GET TOKEN
    if($cookies.get('token_instance')){
      const handlerPermission = await axios.get(`${process.env.VUE_APP_STATUS == 'DEV' ? process.env.VUE_APP_API_DEV : process.env.VUE_APP_API_PRODUCTION}company/user/check`, {
        headers: { 'Authorization': `Bearer ${$cookies.get("token_instance")}` }
      })

      // HANDLE INSTANCE PERMISSION
      store.commit('setPermission', handlerPermission.data.data.permissions)
      store.commit('setUserData', handlerPermission.data.data)
      if(handlerPermission.data.data.permissions.includes(to.meta.pagePermission)){
        next()
      }else{  // RETURN TO 403
        next('/403')
      }
    }else{ // RETURN TO LOGIN
      next('/')
    }
  }
  // IF GUARDED WITH ADMIN
  else if(to.matched.some(record => record.meta.authAdmin)){
    // GET TOKEN
    if($cookies.get('token_admin')){
      next()
    }else{ // RETURN TO LOGIN
      next('/admin/login')
    }
  }
  // IF GUARDED WITH ADMIN
  else if(to.matched.some(record => record.meta.authGroup)){
    // GET TOKEN
    if($cookies.get('token_group')){
      next()
    }else{ // RETURN TO LOGIN
      next('/group/login')
    }
  }
  // ELSE
  else{
    if($cookies.get('token_instance')){
      if(to.path == '/instance/login'){
        next('/instance/dashboard')
      }
    }
    next()
  }
})

export default router
